import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import styles from "./timepicker.module.scss";
import { InputWithIcon } from "src/components/input";
import moment from "moment";

interface TimePickerProps {
  value: any;
  onChange: (date: any) => void;
  customInput?:any
  minTime?: Date;
  maxTime?: Date;
}

const CustomInput = ({ value, onClick }: any) => {
  return (
    <InputWithIcon className={styles.cursor} icon="paperflite-clock" value={value} onClick={onClick} />
  );
};

const TimePicker: React.FC<TimePickerProps> = ({ value, onChange, customInput = <CustomInput/>, minTime, maxTime }) => {
  const parsedTime = value !== "pick a time" ? moment(value, "hh:mm A").toDate() : null; 
  
  return (
    <div className={styles.container}>
      <DatePicker
        customInput={customInput}
        onChange={(date) => date && onChange(date)}
        value={value}
        showTimeSelect
        showTimeSelectOnly
        popperClassName={styles.calendar}
        timeIntervals={60}
        dateFormat="LT"
        selected={parsedTime}
        timeCaption="Time"
        minTime={minTime}
      maxTime={maxTime}
      />
    </div>
  );
};

export default TimePicker;
